import { UserRole } from "@services/http/responses/AccountResponse";
import {
  ActionBaseAuth,
  ActionTypesAuthE,
  ActionUpdateAuth,
  IAuthorization,
} from "./actionTypes";
import AUTHSTATES from "./AuthStates";

const InitialState: IAuthorization = {
  id: 0,
  state: AUTHSTATES.UNAUTHORIZED, //isTokenAlive() ? AuthStates.AUTHORIZED : AuthStates.UNAUTHORIZED,
  isAdmin: false,
  role: UserRole.User,
  uuid: "",
  name: "",
  email: {
    isPrivate: false,
    value: ""
  },
  m_online: 0,
  m_low: 0,
  m_offline: 0,
};

const initialState: IAuthorization = { ...InitialState };

export const auth = (state = initialState, action: ActionBaseAuth) => {
  switch (action.type) {
    case ActionTypesAuthE.INIT:
      return state;
    case ActionTypesAuthE.UPDATE_AUTH:
      return { ...(action as ActionUpdateAuth).payload };
    case ActionTypesAuthE.LOGOUT:
      return { ...InitialState };
    default:
      return state;
  }
};
